import Fingerprint2 from 'fingerprintjs2'

import { b64EncodeUnicode } from '../../helpers/base64'
import gqlCheckoutService from '../gql-query/checkoutQuery'
import HausmartService from './HausmartService'

import { client as apolloClient } from 'api/apolloClient'
import { Geometry } from 'api/models/Store'
import Product from 'api/models/Product'

const endpoint = '/v2/paypal'

type ShippingData = {
  recipient_name: string
  line_1: string
  line2: string
  city: string
  postal_code: string
  country_code: string
  state: string
  phone: string
  store: string
  note: string
}

type CheckoutOrderData = {
  paypal_order_id: string
  checkoutUrl: string
  paypalOrderId: string
  isFromStock: boolean
  autoCancelDate: string
  errorDebugId: string
  errors: {
    field: string
    messages: string[]
    path: string
  }
}

class PaypalService extends HausmartService {
  buyer_device_id: string | null = null
  constructor(endpoint: string) {
    super(endpoint)

    // Fingerprint2.getV18({}, result => {
    //   this.buyer_device_id = result
    // })
    const fpInstance = new Fingerprint2()
    fpInstance.get(result => {
      this.buyer_device_id = result
    })
  }

  /*
   * Not used any more. Keep in code in case a rollback is needed.
   * Delete after 2019-05-01.
   */
  /* checkoutOrders (client, id = '5b351c5364b1011fb4256531', items = [], storeGeometry, shipping, email, isPickupSelected) {
    let { latitude, longitude } = storeGeometry
    return this.api.post(`checkout/orders/${id}/guest_buyer`, {
      items: items.map(item => Object.assign({}, item, { id: item._id, quantity: item.count })),
      location: { latitude: latitude, longitude: longitude },
      payment_origin: 'WEB',
      buyer_device_id: this.buyer_device_id,
      is_pickup: isPickupSelected,
      shipping,
      ...(email && { email })
    })
  } */

  /*
   * Not used any more. Keep in code in case a rollback is needed.
   * Delete after 2019-05-01.
   */
  /* getPaymentStatus (client, id, PayerID) {
    return this.api.post(`checkout/orders/${id}/pay`, {
      PayerID
    })
  } */

  setPaymentCancel(id: string, PayerID = null) {
    return this.api.post(`/checkout/orders/${id}/cancel`, {
      PayerID
    })
  }

  checkoutOrders(
    id = '5b351c5364b1011fb4256531',
    items: Product[] = [],
    storeGeometry: Geometry,
    shipping: boolean,
    email: string,
    isPickupSelected: boolean,
    ct?: string,
    isTablePickup?: boolean,
    tableNumber?: string
  ): Promise<CheckoutOrderData> {
    return new Promise((resolve, reject) => {
      const { latitude, longitude } = storeGeometry

      const shippingInfo =
        (shipping && {
          fullName: (document?.getElementById('recipient_name') as HTMLInputElement)?.value || '',
          line1: (document?.getElementById('line_1') as HTMLInputElement)?.value || '',
          line2: (document?.getElementById('line_2') as HTMLInputElement)?.value || '',
          city: (document?.getElementById('city') as HTMLInputElement)?.value || '',
          postalCode: (document?.getElementById('postal_code') as HTMLInputElement)?.value || '',
          countryCode: (document?.getElementById('country_code') as HTMLInputElement)?.value || '',
          state: (document?.getElementById('state') as HTMLInputElement)?.value || '',
          phone: (document?.getElementById('phone') as HTMLInputElement)?.value || '',
          store: (document?.getElementById('store') as HTMLInputElement)?.value || '',
          note: (document?.getElementById('note') as HTMLInputElement)?.value || ''
        }) ||
        null

      apolloClient
        .mutate({
          mutation: gqlCheckoutService.checkoutOrderMutation,
          variables: {
            storeId: b64EncodeUnicode(`EnterStoreType:${id}`),
            email: email,
            isPickup: isPickupSelected,
            buyerDeviceId: this.buyer_device_id,
            paymentOrigin: 'WEB',
            longitude: longitude,
            latitude: latitude,
            items: items.map(item => ({
              productId: b64EncodeUnicode(`EnterStoreProductType:${item._id}`),
              quantity: item.count,
              price: item.price,
              productSubOptions:
                item.product_sub_options &&
                item.product_sub_options.map(pso => ({
                  items: pso.items.map(item => ({ productSubOptionId: item.productSubOptionId, price: item.price }))
                })),
              comments: item.comments
            })),
            shipping: shippingInfo,
            ct,
            isTablePickup,
            tableNumber
          }
        })
        .then(resp => {
          const { data } = resp
          if (data.checkoutOrder.errors) {
            reject(data.checkoutOrder)
          } else {
            resolve({
              paypal_order_id: data.checkoutOrder.paypalOrderId,
              ...data.checkoutOrder
            })
          }
        })
        .catch(error => {
          reject(error.graphQLErrors)
        })
    })
  }

  checkoutOrdersPay(id: string) {
    return new Promise((resolve, reject) => {
      apolloClient
        .mutate({
          mutation: gqlCheckoutService.checkoutOrderPayMutation,
          variables: {
            paypalOrderId: id
          }
        })
        .then(({ data }) => {
          const checkoutOrdersPaySuccess = data.checkoutOrderPay.success
          if (checkoutOrdersPaySuccess) {
            resolve(checkoutOrdersPaySuccess)
          } else {
            reject(checkoutOrdersPaySuccess)
          }
        })
        .catch(error => {
          reject(JSON.stringify(error))
        })
    })
  }
}

export default new PaypalService(endpoint)
